import React from 'react';

// Partnership Management - Referral Links (User Management CSS)
const ReferralLinksTab = () => {
  return (
    <div className="tab-content">
      <div className="user-controls">
        <div className="search-box">
          <input type="text" placeholder="Search partners or codes" />
          <span className="material-icons">search</span>
        </div>
      </div>

      <table className="users-table">
        <thead>
          <tr>
            <th>Partner</th>
            <th>Referral Code</th>
            <th>Clicks</th>
            <th>Signups</th>
            <th>Active Students</th>
            <th>Conversion Rate</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Example Teacher</td>
            <td>teacher-rihani-247</td>
            <td>500</td>
            <td>100</td>
            <td>80</td>
            <td>20%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ReferralLinksTab;

